module.exports = __webpack_public_path__ + "static/media/CapaLoginAppAssessorTech.e082a455.svg";